import { type ListOfErrors } from '#app/components/form/types.ts'

export function ErrorList({
	id,
	errors,
}: {
	errors?: ListOfErrors
	id?: string
}) {
	const errorsToRender = errors?.filter(Boolean)
	if (!errorsToRender?.length) return null
	return (
		<ul id={id} className="flex flex-col gap-1">
			{errorsToRender.map((error, index) => (
				<li key={index} className="text-foreground-destructive text-[11px]">
					{error}
				</li>
			))}
		</ul>
	)
}
